import icon from 'vue-svgicon';

icon.register({
    'regular/button-refresh-arrows': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.25 14.248v4.5H.75M18.75 9.748v-4.5h4.5M19.032 5.245A9.752 9.752 0 0 1 8.246 21M4.967 18.751A9.753 9.753 0 0 1 15.754 3"/>`,
    },
});
